import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHelperService } from '../../utilities/http-helper/http-helper.service';
import { Observable } from 'rxjs';
import { CalendarInput } from '../../models/calendar/calendar-input';
import { ScheduleCreate } from '../../models/settings/daily-schedule-create';
import { AppointmentInput } from '../../models/calendar/appointment-input';
import { CalendarEvents, Subscription } from '../../models/calendar/calendar-events';
import { DailySchedule } from '../../models/settings/daily-schedule.model';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  baseUrl: string = environment.apiBaseUrl;

  constructor(
    private http: HttpClient,
    private httpHelper: HttpHelperService
  ) { }

  getAppointmentsList(paramsReq: CalendarInput): Observable<Subscription[]> {
    let params = new HttpParams()
      .set('StylistId', paramsReq.StylistId)
      .set('WeekNum', paramsReq.WeekNum)
      .set('Year', paramsReq.Year)
      .set('RecordStatus', paramsReq.RecordStatus)
    const apiUrl = this.httpHelper.getApiUrl(`api/Appointments/GetAppointmentsByStylistIdAndWeekNum`);
    return this.http.get<Subscription[]>(apiUrl, { params: params });
  }

  getAppointmentById(id: number): Observable<CalendarEvents[]> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Appointments/GetAppointmentsById`);
    let params = new HttpParams()
      .set('AppointmentId', id)
    return this.http.get<CalendarEvents[]>(apiUrl, { params: params })
  }

  updateAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Appointments/StylistUpdateAppointment`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put<AppointmentInput>(apiUrl, data, requestOptions);
  }

  cancelAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Appointments/CancelAppointment`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put<AppointmentInput>(apiUrl, data, requestOptions);
  }

  approveAndRejectAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Appointments/UpdateApproveRejectAppointment`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put<AppointmentInput>(apiUrl, data, requestOptions);
  }

  getOpenHours(paramsReq: CalendarInput): Observable<DailySchedule[]> {
    let params = new HttpParams()
      .set('StylistId', paramsReq.StylistId)
      .set('WeekNum', paramsReq.WeekNum)
      .set('Year', paramsReq.Year)
    const apiUrl = this.httpHelper.getApiUrl(`api/OpenHours/GetOpenHoursByWeekNumber`);
    return this.http.get<DailySchedule[]>(apiUrl, { params: params });
  }

  getClosedHours(paramsReq: CalendarInput): Observable<DailySchedule[]> {
    let params = new HttpParams()
      .set('StylistId', paramsReq.StylistId)
      .set('WeekNum', paramsReq.WeekNum)
      .set('Year', paramsReq.Year)
    const apiUrl = this.httpHelper.getApiUrl(`api/ClosedHours/GetClosedHourByWeekNumAndMonthNum`);
    return this.http.get<DailySchedule[]>(apiUrl, { params: params });
  }
  createClosedHours(data: ScheduleCreate): Observable<ScheduleCreate> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/ClosedHours/CreateClosedHours`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post<ScheduleCreate>(apiUrl, data, requestOptions);
  }

  updateClosedHours(data: ScheduleCreate): Observable<ScheduleCreate> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/ClosedHours/UpdateClosedHour`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put<ScheduleCreate>(apiUrl, data, requestOptions);
  }

  getClosedHoursById(id: number): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/ClosedHours/GetClosedHourById`);
    let params = new HttpParams()
      .set('Id', id)
    return this.http.get(apiUrl, { params: params })
  }

  appointmentValidation(data: ScheduleCreate): Observable<ScheduleCreate> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/ClosedHours/CreateUpdateClosedHourValidation`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put<ScheduleCreate>(apiUrl, data, requestOptions);
  }
}
